<template lang="html">
  <div class="freelancing"
  data-aos="fade-left"
  data-aos-easing="ease-out-quad"
  data-aos-duration="250">
    <div class="heading">
      <h1>Freelance Work</h1>
      <hr>
    </div>

    <div >
      <div class="main-project">
        <div class="projects">
          <div class="main-laptop projects-detail">
            <img src="../assets/pastprojects/6centconcert.png" alt="">
            <p>The 6 Concert (Ft. Drake and DJ ESCO)</p>
          </div>
        </div>
      </div>
    </div>

    <div class="recent-projects">
      <div class="projects-detail">
        <img src="../assets/pastprojects/ru-pass.png" alt="">
        <p><b>RU PASS</b> - A service that provides full-time degree Ryerson students with unlimited use of transit via TTC services.</p>
      </div>
      <div class="projects-detail">
        <img src="../assets/pastprojects/konnecttallent.png" alt="">
        <p><b>Konnect Talent</b> - Recruitment firm</p>
      </div>
      <div class="projects-detail">
        <img src="../assets/pastprojects/tedxryerson-min.png" alt="">
        <p><b>TEDxRyersonU 2018</b></p>
      </div>
      <div class="projects-detail">
        <img src="../assets/pastprojects/vote-unify.png" alt="">
        <p><b>Vote Unify</b> - 2018 RSU elections</p>
      </div>
    </div>

    <div class="past-projects" id="load-projects">
      <div class="projects">
        <div class="projects-detail">
          <img src="../assets/pastprojects/petvusite.png" alt="">
          <p>Pet Vu - Online shop for a GPS Pet Tracking device sold accross Canada</p>
        </div>
        <div class="projects-detail">
          <img src="../assets/pastprojects/lavietoronto.png" alt="">
          <p>La Vie Toronto Club</p>
        </div>
        <div class="projects-detail">
          <img src="../assets/pastprojects/endofexamszn.png" alt="">
          <p>End Of Exam SZN Mega Party (Ft. Jordan from Majid Jordan and OB OBRIEN from OVO)</p>
        </div>
        <div class="projects-detail">
          <img src="../assets/pastprojects/impactruw.png" alt="">
          <p>ImpactRU - student group running for the 2016-17 RSU Elections</p>
        </div>
        <div class="projects-detail">
          <img src="../assets/pastprojects/rajan.png" alt="">
          <p>Rajan - Rapper</p>
        </div>
        <div class="projects-detail">
          <img src="../assets/pastprojects/rectoronto.png" alt="">
          <p>REC - One day entertainment business conference</p>
        </div>
        <div class="projects-detail">
          <img src="../assets/pastprojects/sparklingeventsmanagement.png" alt="">
          <p>Sparkling Events Management offers catering services to businesses</p>
        </div>
        <div class="projects-detail">
          <img src="../assets/pastprojects/halloweencarnival.png" alt="">
          <p>Party hosted for Ryerson on Halloween</p>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  data:function(){
    return {
      showMore: 0,
      btnTxt : 'Show More'
    }
  },
  methods : {
    loadMore : function() {
      var loadProjects = document.getElementById('load-projects');
      this.showMore++;
      console.log(this.showMore);
      if(this.showMore % 2) {
        this.btnTxt = 'Show Less'
        loadProjects.className = "past-projects show"
      } else {
        this.btnTxt = 'Show More'
        loadProjects.className = "past-projects hide"
      }
    }
  }
}
</script>

<style lang="scss">

.freelancing {
  margin-bottom: 100px;

  .btn-primary{
    margin: auto;
  }

  .recent-projects {
      margin-top: 20px;
      display: grid;
      grid-template-columns: 50% 50%;
      text-align: left;

      .projects-detail {
        text-align: center;
        padding: 10px;
        box-shadow: none;

        img {
          border-radius: 5px;
          border: none;
          width: 100%;
          box-shadow: none;
        }
      }
  }

  .main-project {
      .projects-detail {
        text-align: center;
        padding: 10px;
        box-shadow: none;

        img {
          border-radius: 5px;
          border: none;
          width: 40%;
          box-shadow: none;
        }
      }
  }


  .past-projects{
    margin-top: 60px;

    img {
      border-radius: 5px;
      border: none;
      width: 70%;
    }

    .projects {
        margin-top: 20px;
        display: grid;
        grid-template-columns: 50% 50%;
        text-align: left;

        .projects-detail {
          text-align: center;
          padding: 10px;

          img {
            border-radius: 5px;
            box-shadow: none;
            border: none;
            width: 100%;
          }
        }
      }

    .main-laptop{

      img {
        width: 100%;
        border: none;
        box-shadow: none;
      }
    }
  }
}


@media only screen and (max-width: 900px) {
  .freelancing {
    .recent-projects {
        text-align: center;
        display: grid;
        grid-template-columns: 100%;
    }

    .past-projects {
        .projects{
          grid-template-columns: 100%;
        }

        .main-laptop{
          img {
            width: 100%;
            border: none;
            box-shadow: none;
          }
        }
    }
  }
}



</style>
